// "https://azusc-pkgloop-admin-web-dev.azurewebsites.net/api/v1.0/customer-portal/pre-built-packages/get/1"
import "../../WidgetModal.css";
import "react-day-picker/lib/style.css";

import React, { useEffect, useContext, useState, SetStateAction } from "react";
import { Col, Row, Spinner, Button, Modal, Form } from "react-bootstrap";
import { WidgetContext } from "../../../../../../../context/WidgetContext";
import { DatesAndGuests } from "../../../../widget-form/WidgetForm";
import PackageDetails from "./PackageDetails";
import CustomDayPickerInput from "../../../../../customDayPickerInput/CustomDayPickerInput";
import reactMoment from "react-day-picker/moment";
import { Modifier } from "react-day-picker";
import moment from "moment";
import { PreBuiltPkg } from "../Models/PreBuiltPkg";

interface props {
  show: boolean;
  pkg: PreBuiltPkg;
  onHide: () => void;
  datesAndGuestsState: [DatesAndGuests, React.Dispatch<SetStateAction<DatesAndGuests>>];
  onSelectedPackage: (pkg: any) => void;
}

const PackageDetailsModal: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint } = useContext(WidgetContext);
  const [datesAndGuests, setDatesAndGuests] = props.datesAndGuestsState;
  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";
  const { formatDate, parseDate } = reactMoment;
  const modifiers = { start: datesAndGuests.fromDate, end: datesAndGuests.toDate };

  useEffect(() => {
    if (props.pkg === undefined) return;
    const travelDaysAllow = props.pkg.travelDaysAllowed ?? 3
    // set the dates and guests date obj to whatever the span is starting with todays date
    const daysFromStartingDate = new Date(datesAndGuests.fromDate.getTime() + (1000 * 60 * 60 * 24 * travelDaysAllow));

    const allowed = moment(datesAndGuests.fromDate).isSameOrAfter(props.pkg.validToTravelFrom);
    setDatesAndGuests({ ...datesAndGuests, toDate: daysFromStartingDate});
  }, [props.pkg]);

  return (
    <Modal
      show={props.show}
      size="lg"
      onHide={() => { props.onHide(); }}
      backdropClassName="white-overlay"
      dialogClassName="box-shadow"
    >
      <Modal.Header translate="" closeButton closeLabel="close window">
        <div className="w-100">
          <Modal.Title className="font-weight-bold">{props.pkg ? props.pkg.packageName : "undefined"}</Modal.Title>
          <Row className="">
            {/* <p className="itinerary-info mr-2 mb-0"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.fromDate ? datesAndGuests.fromDate.toDateString() : "Arrive"}</p>
            <p className="itinerary-info mb-0"> - </p>
            <p className="itinerary-info ml-2 mb-0"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.toDate ? datesAndGuests.toDate.toDateString() : "Depart"}</p> */}
            <Col xs={12} md={6} className="InputFromTo d-flex flex-column mb-3">
              <CustomDayPickerInput
                value={`Arrive: ${moment(datesAndGuests.fromDate).format("ddd, MMM Do, YYYY")}`}
                placeholder="From"
                format="LL"
                formatDate={formatDate}
                parseDate={parseDate}
                inputProps={{ required: "required", style: { color: style.fontColor } }}
                // style={{ color: style.fontColor }}
                dayPickerProps={{
                  selectedDays: { from: datesAndGuests.fromDate, to: datesAndGuests.toDate } as Modifier,
                  disabledDays: {
                    // before: props.pkg !== undefined && props.pkg.validToTravel ? moment(props.pkg.validToTravelFrom).format("MM/DD/YY") : new Date(),
                    // after: props.pkg !== undefined && props.pkg.validToTravel ? moment(props.pkg.validToTravelEnd).format("MM/DD/YY") : undefined
                    },
                  modifiers,
                  numberOfMonths: 1,
                  month: datesAndGuests.fromDate,
                }}
                onDayChange={(date: Date) => {
                  datesAndGuests.fromDate = date;
                  if (datesAndGuests.toDate && date > datesAndGuests.toDate) {
                    datesAndGuests.toDate = date;
                  }
                  setDatesAndGuests({ ...datesAndGuests });
                }}
              />
            </Col>

            <Col xs={12} md={6} className="InputFromTo d-flex flex-column mb-3">
              <CustomDayPickerInput
                value={`Depart: ${moment(datesAndGuests.toDate).format("ddd, MMM Do, YYYY")}`}
                placeholder="To"
                format="LL"
                formatDate={formatDate}
                parseDate={parseDate}
                inputProps={{ required: "required", style: { color: style.fontColor } }}
                dayPickerProps={{
                  selectedDays: { from: datesAndGuests.fromDate, to: datesAndGuests.toDate } as Modifier,
                  // disabledDays: {
                  //   before: props.pkg !== undefined && props.pkg.validToTravel ? moment(props.pkg.validToTravelFrom).format("MM/DD/YY") : new Date(),
                  //   // after: props.pkg !== undefined && props.pkg.validToTravel ? moment(props.pkg.validToTravelEnd).format("MM/DD/YY") : undefined,
                  // },
                  modifiers,
                  month: datesAndGuests.fromDate,
                  fromMonth: datesAndGuests.fromDate,
                  numberOfMonths: 1
                }}
                onDayChange={(date: Date) => {
                  datesAndGuests.toDate = date;
                  setDatesAndGuests({ ...datesAndGuests });
                }}
              />
            </Col>
          </Row>
          <div className="d-flex flex-row justify-content-between m-0 p-0">
            <p className="font-weight-bold orange-text m-0 p-0">{props.pkg ? props.pkg.description : "Description"}</p>
            <p className="font-weight-bold green-text m-0 p-0">From ${(props.pkg ? props.pkg.fromPrice : "")} <span className="small"></span></p>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        {props.pkg && (
          <PackageDetails
            pbPackage={props.pkg}
            datesAndGuests={datesAndGuests}
            onSelectedPackage={(pkg: any) => {
              props.onSelectedPackage(pkg);
              props.onHide();
            }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default PackageDetailsModal;  